import { api } from '@smena/ui';

export interface VapidResponse {
  publicKey: string;
  ready: boolean;
}

export function fetchVapid(): Promise<VapidResponse> {
  return api('/api/staff/push/vapid');
}

export interface SubscribeInput {
  endpoint: string;
  keys: { p256dh: string; auth: string };
}

export function subscribePush(input: SubscribeInput): Promise<{ ok: true }> {
  return api('/api/staff/push/subscribe', { method: 'POST', json: input });
}

export function unsubscribePush(endpoint: string): Promise<{ ok: true }> {
  return api('/api/staff/push/unsubscribe', { method: 'POST', json: { endpoint } });
}

export function sendPushTest(title?: string, body?: string): Promise<{ sent: number; removed: number }> {
  return api('/api/staff/push/test', { method: 'POST', json: { title, body } });
}
